import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const ClientPlan = () => {
  const [plan, setPlan] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/portal/plan`, { withCredentials: true }).then(r => setPlan(r.data)).catch(() => {});
  }, []);

  if (!plan) return <div className="portal-loading">Loading...</div>;

  return (
    <div data-testid="client-plan">
      <h1 className="portal-page-title">My Plan</h1>
      <p className="portal-page-subtitle">Your R6 Advisory subscription details</p>

      <div className="portal-card">
        <span className="portal-badge">Current Plan</span>
        <h3 style={{ marginTop: '0.75rem', fontSize: '1.25rem' }}>{plan.name}</h3>
        <p className="portal-stat-value" style={{ color: '#C8963E' }}>{plan.price}</p>
        <p style={{ marginTop: '0.75rem' }}>{plan.includes}</p>
      </div>

      <div className="portal-card">
        <h3>Account Details</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '140px 1fr', gap: '0.5rem 1rem', marginTop: '0.75rem' }}>
          <span style={{ color: '#5A6C8A', fontSize: '0.88rem' }}>Name</span>
          <span style={{ color: '#1B2A4E', fontWeight: 500 }}>{plan.client_name}</span>
          {plan.company && (
            <>
              <span style={{ color: '#5A6C8A', fontSize: '0.88rem' }}>Company</span>
              <span style={{ color: '#1B2A4E', fontWeight: 500 }}>{plan.company}</span>
            </>
          )}
        </div>
      </div>

      <div className="portal-card" style={{ background: '#F8F9FB' }}>
        <h3>Need to upgrade or change your plan?</h3>
        <p style={{ marginTop: '0.5rem' }}>Contact your R6 advisor to discuss plan adjustments, additional sessions, or the Ask the Expert option.</p>
        <a href="https://form.jotform.com/260186646305054" target="_blank" rel="noopener noreferrer" className="portal-btn portal-btn-primary" style={{ marginTop: '1rem' }}>Contact R6 Collective</a>
      </div>
    </div>
  );
};

export default ClientPlan;
